import mutations from './bulk/mutations';
import actions from './bulk/actions';
import getters from './bulk/getters';

const bulk = {
  namespaced: true,
  state: {
    item: {
      courses: [],
      codes: [],
    },
    isLoading: false,
  },
  mutations,
  actions,
  getters,
};

export default bulk;
